import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'tidy-image',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./image.component.scss'],
    template: `
    <!-- Use regular img tag for eager loading to respect browser cache -->
    @if (loading === 'eager') {
      <img
        [style.width]="width"
        [src]="src"
        [class.hoverable]="hoverSrc"
        [class.clickable]="action.observers?.length"
        [class.active]="isActive"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        (load)="imageLoaded()"
        (click)="executeAction()"
        style="object-fit: contain;">
    }
    
    <!-- Use ion-img for lazy loading -->
    @if (loading !== 'eager') {
      <ion-img
        [style.width]="width"
        [src]="src"
        [attr.loading]="loading"
        [class.hoverable]="hoverSrc"
        [class.clickable]="action.observers?.length"
        [class.active]="isActive"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        (ionImgDidLoad)="imageLoaded()"
        (click)="executeAction()">
      </ion-img>
    }
    `,
    standalone: false
})

export class ImageComponent implements OnInit {
  @Input() src: string;
  @Input() hoverSrc: string;
  @Input() color: string;
  @Input() loading: 'lazy' | 'eager' = 'eager';  // Default to lazy for backward compatibility
  @Input() isActive = false;
  @Output() action: EventEmitter<any> = new EventEmitter();
  @Output() imageDidLoad: EventEmitter<void> = new EventEmitter<void>();
  @Input() width: string;

  private originalSrc: string;

  ngOnInit() {
    this.originalSrc = this.src;
  }

  onMouseEnter() {
    if (this.hoverSrc) {
      this.src = this.hoverSrc;
    }
  }

  onMouseLeave() {
    if (this.hoverSrc) {
      this.src = this.originalSrc;
    }
  }

  executeAction() {
    this.action.emit();
  }

  imageLoaded() {
    this.imageDidLoad.emit();
  }
}
